import { ItiBaseDto } from '@/iti-core-vue';

export class CollaborativeAreaType extends ItiBaseDto {
    public name !: string;

    constructor(id: number, name: string) {
        super();
        this.id = id;
        this.name = name;
    }
}